import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { WITHDRAWAL_TRANSLATION } from '../../constants/common';
import {
  StyledButtonContent,
  StyledExternalLink,
  StyledHandledReset,
  StyledMessageContainer,
  StyledSubmitted,
  StyledSuccessIconWithdrawal,
  StyledSuccessPageContainer,
  StyledParagraph,
} from './SuccessPage.styles';
import { SuccessPageProps } from './SuccessPage.types';

const SuccessPage: FC<SuccessPageProps> = ({ handleResetForm, requestId }) => {
  const { t } = useTranslation(WITHDRAWAL_TRANSLATION);

  return (
    <StyledSuccessPageContainer>
      <StyledSuccessIconWithdrawal data-testid={'success-icon'} />
      <StyledSubmitted>{t('submitted')}</StyledSubmitted>
      <StyledMessageContainer>{t('message')}</StyledMessageContainer>
      <StyledParagraph>
        {t('confirmation_id')}
        {requestId}
      </StyledParagraph>
      <StyledExternalLink href="https://helix.privacyportal.co/" target="_blank" rel="noopener noreferrer">
        {t('view_your_requests')}
      </StyledExternalLink>
      <StyledButtonContent>
        <StyledHandledReset data-testid={'reset-link'} onClick={handleResetForm}>
          {t('add')}
        </StyledHandledReset>
      </StyledButtonContent>
    </StyledSuccessPageContainer>
  );
};

export default SuccessPage;
